import Vue from 'vue'

import account from './account'
import accounts from './accounts'
import ccdb from './ccdb'
import common from './common'
import contract from './contract'
import employee from './employee'
import form from './FormMixin'
import invoice from './invoice'
import job from './job'
import loadAccount from './load-account'
import loadAccounts from './load-accounts'
import loadCcdb from './load-ccdb'
import loadJob from './load-job'
import loadOrder from './load-order'
import loadReference from './load-reference'
import loadZone from './load-zone'
import loading from './loading'
import login from './login'
import lookups from './lookups'
import notificationMethods from './notification-methods'
import order from './Order'
import orderPortLag from './OrderPortLag'
import reference from './reference'
import table from './table'
import title from './title'
import user from './user'
import zone from './zone'

const autoMix =
{
	common,
	employee,
	loading,
    login,
	user,
}

Object.keys(autoMix).forEach(key => Vue.mixin(autoMix[key]))

export
{
	account,
	accounts,
	ccdb,
	common,
	contract,
	employee,
	form,
	job,
	loadAccount,
	loadAccounts,
	loadCcdb,
	loadJob,
	loadOrder,
	loadReference,
	loadZone,
	loading,
	lookups,
	notificationMethods,
	order,
	orderPortLag,
	invoice,
	reference,
	table,
	title,
	user,
	zone,
	login
}